const SET_NEW_OFFERS = 'OFFERS/SET_NEW_OFFERS'
const SET_OFFERS = 'OFFERS/SET_OFFERS'
const SET_REWARDS = 'OFFERS/SET_REWARDS'
const SET_OFFER_MODAL_DATA = 'OFFERS/SET_OFFER_MODAL_DATA'
const SET_REWARD_MODAL_DATA = 'OFFERS/SET_REWARD_MODAL_DATA'
const SET_REWARDS_CATALOG = 'OFFERS/SET_REWARDS_CATALOG'
const SET_OFFER_MODAL_STATUS = 'OFFERS/SET_OFFER_MODAL_STATUS'
const SET_REWARD_MODAL_STATUS = 'OFFERS/SET_REWARD_MODAL_STATUS'

// TODO: add more action types if necessary

export {
  SET_NEW_OFFERS,
  SET_OFFERS,
  SET_REWARDS,
  SET_OFFER_MODAL_DATA,
  SET_OFFER_MODAL_STATUS,
  SET_REWARD_MODAL_DATA,
  SET_REWARD_MODAL_STATUS,
  SET_REWARDS_CATALOG,
  // TODO: export action types added later
}
